import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "2 Up (CAN LEDE, 2 Topics)",
    description: "This package shows 2 stories, one left and one right.",
    links: [
        {
            name: "Editorial Team Guide",
            url: "https://docs.google.com/document/d/1XVAaeEBxk8ifuhKiUqNn_jvpwPbTet681IRnLv4MLRQ/edit?tab=t.0#heading=h.f1by2kyhmtdq",
        },
        {
            name: "Module Library",
            url: "https://docs.google.com/document/d/1JORaUFwMtPyyoUflTRHKINyllR4zWIJV1bL66Abutis/edit?tab=t.0#heading=h.n8hlmw8itrg7",
        },
        {
            name: "Figma",
            url: "https://www.figma.com/design/gMELOCd5MiIqECTbVITX8y/Homepage?node-id=1473-36490&m=dev",
        },
    ],
};
